import HttpService from './baseHttp'
// 获取erpsku
export const HttpGetErpsku = (data = {}) => HttpService.get('/api/v1/Product/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 销毁计划分页查询
export const HttpGetDestoryPlanByPage = (data = {}) => HttpService.get('/api/v2/destroyPlanOrder/findByPage', { params: data })
// 获取所有项目
export const HttpGetAllOrg = (data, config) => HttpService.post('/api/v1/Organization/selectByPage', data, { ...config, baseURL: process.env.VUE_APP_APIURL_UC })
// 获取仓库
export const HttpWarehouse = (data) => HttpService.get('/api/v2/warehouse/findAllWarehouses', data, { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 销毁计划提交
export const HttpSubmitDestoryPlan =  (data, config) => HttpService.post('/api/v2/destroyPlanOrder/submit', data, { ...config })
// 销毁计划撤销审核
export const HttpCancelSubmitDestoryPlan =  (data, config) => HttpService.post('/api/v2/destroyPlanOrder/revokeAudit', data, { ...config })
// sku弹框选择
export const HttpPlanBillErpSku = (data = {}) => HttpService.get("/api/v2/TransferOutboundPlan/findSkuOptions", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 计算重量及体积
export const HttpGetcalculateWeightAndVolume = (data) => HttpService.post('/api/v2/Inbound/calculateWeightAndVolume?contextId=' + data.contextId, data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 上传附件
export const HttpUploadAttachments = (data, config) => HttpService.post('/api/v2/Inbound/attachmentUpload', data, { ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// 删除附件
export const HttpDelAttachments = (data) => HttpService.post('/api/v2/OrderAttach/del', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查看产品
export const HttpGetProductsOne = (data = {}, config) => HttpService.get('/api/v1/Product/getById', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 创建销毁计划
export const HttpCreateDestoryPlan = (data = {}, config) => HttpService.post('/api/v2/destroyPlanOrder/create', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
// 查看销毁计划单
export const HttpGetDestoryPlanOne = (data = {}, config) => HttpService.get('/api/v2/destroyPlanOrder/queryRow', { params: data })
// 查看产品列表
export const HttpGetDestoryPlanProductList = (data = {}, config) => HttpService.get('/api/v2/destroyPlanOrderItem/findByDestroyPlanOrderId', { params: data })
// 查看产品
export const HttpGetDestoryLog = (data = {}, config) => HttpService.get('/api/v2/OrderLog/query', { params: data })
// 编辑更新
export const HttpUpdateDesotryPlan = (data = {}, config) => HttpService.post('/api/v2/destroyPlanOrder/update', data, { headers: { "Content-Type": "application/json" } })
// 销毁计划提交
export const HttpDestoryPlanSubmit = (data = {}, config) => HttpService.post('/api/v2/destroyPlanOrder/submit', data)
// 销毁计划撤销审核
export const HttpDestoryPlanCancelCommit = (data = {}, config) => HttpService.post('/api/v2/destroyPlanOrder/revokeAudit', data)
// 销毁计划审核
export const HttpDestoryPlanCommit = (data = {}, config) => HttpService.post('/api/v2/destroyPlanOrder/audit', data)
// 销毁单列表
export const HttpDestoryOrderList = (data = {}, config) => HttpService.get('/api/v2/destroyOrder/findByPage', { params: data })
// 附件列表查询
export const HttpGetAttachList = (data = {}, config) => HttpService.get('/api/v2/OrderAttach/findByOrderTypeAndOrderId', { params: data })
// 创建销毁单
export const HttpCreateDestoryOrder = (data = {}, config) => HttpService.post('/api/v2/destroyOrder/create', data, { headers: { "Content-Type": "application/json" }})
// 销毁单明细查询
export const HttpGetDestoryDetail = (data = {}, config) => HttpService.get('/api/v2/destroyOrderItem/findByPage', { params: data })
// 销毁单根据id查询
export const HttpGetOrderById = (data = {}, config) => HttpService.get('/api/v2/destroyOrder/queryRow', { params: data })
// 根据销毁单
export const HttpGetSkuByByPlanId = (data = {}, config) => HttpService.get('/api/v2/destroyPlanOrderItem/findByDestroyPlanOrderId', { params: data})
// 销毁计划取消
export const HttpDestoryPlanCancel = (data = {}, config) => HttpService.post('/api/v2/destroyPlanOrder/cancel', data)
// 完成
export const HttpDestoryPlanComplete = (data = {}, config) => HttpService.post('/api/v2/destroyPlanOrder/complete', data)
// 销毁单确认
export const HttpDestoryOrderConfirm = (data = {}, config) => HttpService.post('/api/v2/destroyOrder/confirm', data)
// 销毁单取消
export const HttpDestoryOrderCancel = (data = {}, config) => HttpService.post('/api/v2/destroyOrder/cancel', data)
// 销毁单明细增加
export const HttpDestoryOrderDetailAdd = (data = {}, config) => HttpService.post('/api/v2/destroyOrderItem/save', data)
// 销毁单明细删除
export const HttpDesotryOrderDetailDel = (data = {}, config) => HttpService.post('/api/v2/destroyOrderItem/batchDelete', data)
// 销毁单保存更新
export const HttpDesotryOrderSave = (data = {}, config) => HttpService.post('/api/v2/destroyOrder/update', data, { headers: { "Content-Type": "application/json" }})
// 销毁单一键添加
export const HttpDestoryOrderFastAdd = (data = {}, config) => HttpService.post('/api/v2/destroyOrderItem/fastAddTo', data)
// 销毁单清空
export const HttpDestoryOrderFastClear = (data = {}, config) => HttpService.post('/api/v2/destroyOrderItem/fastClear', data)
// 销毁单获取待销毁数量
export const HttpDestoryOrderGetDestoryQty = (data = {}, config) => HttpService.get('/api/v2/destroyOrder/toBeDestroyQty', { params: data })
// 销毁计划单重推仓库
export const HttpPushWarehouse = (data = {}, config) => HttpService.post('/api/v2/destroyPlanOrder/pushWarehouse', data)
//批量审核
export const HttpDestoryPlanBatchAudit = (data = {}, config) => HttpService.post('/api/v2/destroyPlanOrder/batchAudit', data)
